import { Component, OnInit } from '@angular/core';
import { PaymentService, DiscountPromo } from '@services/payment.service';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'app-discount-manager',
  templateUrl: './discount-manager.component.html',
  styleUrls: ['./discount-manager.component.css'],
})
export class DiscountManagerComponent implements OnInit {
  discounts: DiscountPromo[] = [];
  saving = false;
  draft: DiscountPromo = { name: '', type: 'PERCENT', value: 0, active: true };

  constructor(
    private paymentService: PaymentService,
    private notification: NotificationService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.paymentService.listDiscounts().subscribe((discounts) => {
      this.discounts = discounts || [];
    });
  }

  save(discount: DiscountPromo): void {
    this.saving = true;
    this.paymentService.saveDiscount(discount).subscribe({
      next: () => {
        this.saving = false;
        this.notification.show('success', 'Discount saved');
        this.load();
      },
      error: () => {
        this.saving = false;
        this.notification.show('error', 'Could not save discount');
      },
    });
  }

  add(): void {
    if (!this.draft.name.trim()) {
      return;
    }
    this.save({ ...this.draft });
    this.draft = { name: '', type: 'PERCENT', value: 0, active: true };
  }
}
